const { InnerBlocks, RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { title, text, hrefLink, ButtonText, margin } = attributes;

  return (
    <section className={`Advantage ${margin}`}>
      <div className="Advantage-container Container">
        <RichText.Content
          tagName="h2"
          value={title}
          className="Typography title-6 center color-black margin-extra-small"
        />

        <RichText.Content
          tagName="p"
          value={text}
          className="Typography text center grey margin-medium"
        />

        <div className="Advantage-wrap">
          <div class="Advantage-swiper">
            <div class="swiper-wrapper">
              <InnerBlocks.Content />
            </div>
          </div>
        </div>

        {ButtonText && (
          <a
            href={hrefLink}
            title={ButtonText}
            className="Advantage-button Button Button-center"
          >
            {ButtonText}
          </a>
        )}
      </div>
    </section>
  );
};

export default Save;
